import { useState } from 'react';
import { pathgen } from 'object-path-generator';
import { Badge, Drawer, FullColumn, Row, Typography } from 'seagull';
import { AIEdit24 } from 'seagull/icons';
import styles from "./HelpMeWriteDrawer.module.scss";
import HelpMeWriteTextField from "./HelpMeWriteTextField/HelpMeWriteTextField";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const HelpMeWriteDrawerTestIds = pathgen('HelpMeWriteDrawerTestIds');
const HelpMeWriteDrawer = _ref => {
  let {
    open,
    onClose
  } = _ref;
  const [textValue, setTextValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = () => {
    if (!textValue.trim()) return;
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  };
  const handleActionClick = _action => {};
  return /*#__PURE__*/_jsx(Drawer, {
    open: open,
    onClose: onClose,
    onCloseButtonClick: onClose,
    PaperProps: {
      className: styles.drawerPaper
    },
    showDividers: false,
    header: /*#__PURE__*/_jsxs(Row, {
      gap: 8,
      alignItems: "center",
      "data-testid": HelpMeWriteDrawerTestIds.Header(),
      children: [/*#__PURE__*/_jsx(AIEdit24, {}), /*#__PURE__*/_jsx(Typography, {
        variant: "paragraph1",
        weight: "normal",
        children: "Help me write"
      }), /*#__PURE__*/_jsx(Badge, {
        skin: "primary",
        rounded: true,
        outlined: true,
        children: "Beta"
      })]
    }),
    "data-testid": HelpMeWriteDrawerTestIds.Root(),
    BackdropProps: {
      invisible: true
    },
    children: /*#__PURE__*/_jsx(FullColumn, {
      padding: 16,
      "data-testid": HelpMeWriteDrawerTestIds.Content(),
      children: /*#__PURE__*/_jsx(HelpMeWriteTextField, {
        value: textValue,
        onChange: setTextValue,
        onSubmit: handleSubmit,
        onActionClick: handleActionClick,
        isLoading: isLoading
      })
    })
  });
};
export default HelpMeWriteDrawer;